@if ((showTabLayout$ | async) === false) {
  <div class="page-container">
    @if (scrollEventsLeft === true) {
      <div
        class="page-content left"
        [style.width]="leftWidth + '%'"
        [class.full-side]="hideRightSide"
        [class.hide-side]="hideLeftSide"
        #leftTab
        scrollEnd
        (endReached)="scrollEndReachedLeft(leftTab)"
        [parentSelectorToListenForScroll]="independentScroll ? undefined : (parentSelectorToListenForLeftScroll || '#main-scroll-container')"
        >
        <ng-container [ngTemplateOutlet]="leftTemplate"></ng-container>
      </div>
    }
    @if (scrollEventsLeft !== true) {
      <div
        class="page-content left"
        [style.width]="leftWidth + '%'"
        [class.full-side]="hideRightSide"
        [class.hide-side]="hideLeftSide"
        #leftTab
        >
        <ng-container [ngTemplateOutlet]="leftTemplate"></ng-container>
      </div>
    }
    @if (scrollEventsRight === true) {
      <div
        class="page-content right"
        [style.width]="100 - leftWidth + '%'"
        [class.hide-side]="hideRightSide"
        [class.full-side]="hideLeftSide"
        #rightTab
        scrollEnd
        (scroll)="onScroll($event)"
        (scrollTop)="scrollTopUpdatedRight($event)"
        (endReached)="scrollEndReachedRight(rightTab)"
        [parentSelectorToListenForScroll]="independentScroll ? undefined : (parentSelectorToListenForRightScroll || '#main-scroll-container')"
        >
        <ng-container [ngTemplateOutlet]="rightTemplate"></ng-container>
      </div>
    }
    @if (scrollEventsRight !== true) {
      <div
        class="page-content right"
        [style.width]="100 - leftWidth + '%'"
        [class.hide-side]="hideRightSide"
        [class.full-side]="hideLeftSide"
        #rightTab
        >
        <ng-container [ngTemplateOutlet]="rightTemplate"></ng-container>
      </div>
    }
  </div>
}
@if ((showTabLayout$ | async) === true) {
  <mat-tab-group (selectedTabChange)="selectedTabChangeEvent($event)" mat-stretch-tabs="false" mat-align-tabs="start">
    @if (!hideLeftTab) {
      <mat-tab [label]="leftLabel">
        @if (scrollEventsLeft === true) {
          <div
            class="tab-content-container"
            #leftTab
            scrollEnd
            (endReached)="scrollEndReachedLeft(leftTab)"
            [parentSelectorToListenForScroll]="independentScroll ? undefined : (parentSelectorToListenForLeftScroll || '#main-scroll-container')"
            >
            <ng-container [ngTemplateOutlet]="leftTemplate"></ng-container>
          </div>
        }
        @if (scrollEventsLeft !== true) {
          <div class="tab-content-container">
            <ng-container [ngTemplateOutlet]="leftTemplate"></ng-container>
          </div>
        }
      </mat-tab>
    }
    @if (!hideRightTab) {
      <mat-tab [label]="rightLabel">
        @if (scrollEventsRight === true) {
          <div
            class="tab-content-container"
            #rightTab
            (scroll)="onScroll($event)"
            scrollEnd
            (scrollTop)="scrollTopUpdatedRight($event)"
            (endReached)="scrollEndReachedRight(rightTab)"
            [parentSelectorToListenForScroll]="independentScroll ? undefined : (parentSelectorToListenForRightScroll || '#main-scroll-container')"
            >
            <ng-container [ngTemplateOutlet]="rightTemplate"></ng-container>
          </div>
        }
        @if (scrollEventsRight !== true) {
          <div class="tab-content-container">
            <ng-container [ngTemplateOutlet]="rightTemplate"></ng-container>
          </div>
        }
      </mat-tab>
    }
  </mat-tab-group>
}
